exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: Klavika Regular;\n  src: url(\"/fonts/klavika/Klavika-Regular.ttf\");\n}\n.price[data-v-25e2e1b0] {\n  color: #df0719;\n  font-size: 2rem;\n  text-align: right;\n}\n.price .full[data-v-25e2e1b0] {\n  text-decoration: line-through;\n  color: #444548;\n  font-size: 1.2rem;\n  padding-bottom: 0.8rem;\n}", ""]);

// exports
